module.exports = __webpack_public_path__ + "img/pageDirector.073de3e8.svg";